import { Button, Input, Spinner, Text } from "@chakra-ui/react";

import { InfoCardBody, TextPrimary } from "theme";

import InfoCard from "@components/InfoCard";

interface SubscribeCardProps {
  title?: string;
  subTitle?: string;
  placeholder: string;
  isSubscribing: boolean;
  error: undefined | string;
  email: string;
  onChangeEmail(email: string): void;
  onSubscribe(): void;
}

const SubscribeCard = ({
  title,
  subTitle,
  isSubscribing,
  error,
  email,
  placeholder,
  onChangeEmail,
  onSubscribe,
}: SubscribeCardProps) => {
  return (
    <InfoCard title={title} subTitle={subTitle}>
      <InfoCardBody>
        <Input
          type="email"
          p="16px 24px"
          bg="backgroundPrimary"
          color="textSecondary"
          border="none"
          h="52px"
          fontWeight="400"
          fontSize="14px"
          lineHeight="20px"
          placeholder={placeholder}
          onChange={(e) => {
            onChangeEmail(e?.target?.value);
          }}
          value={email}
        />

        {error && (
          <Text mt="0.5rem" color="error" fontSize="12px" fontWeight="400">
            {error ? error : "error"}
          </Text>
        )}

        <Button
          mt="1.5rem"
          variant="none"
          h="40px"
          background="transparent"
          border="1px solid"
          borderColor="seperator"
          borderRadius="6px"
          p="8px 45px"
          disabled={error !== undefined || isSubscribing}
          onClick={() => onSubscribe()}
          w="162px"
          _hover={{
            bg: "primary",
          }}
        >
          {isSubscribing ? (
            <Spinner size="md" color="primary" />
          ) : (
            <TextPrimary color="textPrimary" fontWeight="600">
              Subscribe
            </TextPrimary>
          )}
        </Button>
      </InfoCardBody>
    </InfoCard>
  );
};

export default SubscribeCard;
